export const PRELOAD = 'PRELOAD'
export const SPLASH = 'SPLASH'
export const INTRO = 'INTRO'
export const VIDEO = 'VIDEO'
export const SHOWCASE = 'SHOWCASE'
export const PRODUCT_INFO = 'PRODUCT_INFO'
export const PRODUCT_DETAILS = 'PRODUCT_DETAILS'



// WEBPACK FOOTER //
// ./src/templates/outSide/scenes.js